<template>
  <IntroAtc
    v-if="variant === 'atc'"
    :close-wording
    :price
    :zone
    @close="emit('close')"
    @next-step="emit('next-step')"
  />
  <IntroPlp
    v-else
    :close-wording
    :price
    @close="emit('close')"
    @next-step="emit('next-step')"
  />
</template>

<script lang="ts" setup>
import IntroAtc from './IntroAtc.vue'
import IntroPlp from './IntroPlp.vue'

interface IntroProps {
  price: string
  closeWording: string
  zone: string
  variant?: 'atc' | 'plp'
}

defineProps<IntroProps>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'next-step'): void
}>()
</script>
